import { PortCatalogData } from 'ais-facade-api/api';
import { InfoWrapper } from '../AISCard';
import styles from './DistanceComponent.module.scss';
import { CountryFlag } from 'CountryFlag/CountryFlag';
import { useTranslation } from 'react-i18next';
interface SelectedPortI {
  port: PortCatalogData;
}

export const SelectedPort = ({ port }: SelectedPortI) => {
  const { t } = useTranslation();
  const displayUnLocode =
    typeof port !== 'undefined' && Object.keys(port).length !== 0 ? `${port?.un} ${port?.locode}` : undefined;

  return (
    <div className={styles.port_info}>
      <InfoWrapper
        label={t('Country')}
        value={port?.meta?.countryName}
        strong
        valueIcon={port?.countryCode && <CountryFlag countryCode={port.countryCode} />}
      />
      <InfoWrapper label="UN/LOCODE" value={displayUnLocode} />
    </div>
  );
};
